/* eslint-disable key-spacing */
/* eslint-disable react/no-danger */
/* eslint-disable react/sort-comp */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable semi */
/* eslint-disable padded-blocks */
/* eslint-disable no-console */
/* eslint-disable indent */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/destructuring-assignment */
import React from 'react'
import Button from 'react-bootstrap/Button'
import * as H from 'history'
import { DashboardController } from '../controllers/DashboardController'
import { ISupportSpinner } from '../shared/Ajax'
// import { ClaimList } from '../models/ClaimList'
import { Backdrop } from '../shared/Backdrop'
import MyDashboard from './applicationForm-2/MyDashboard/index'

interface DashboardPageProps {
    history: H.History
}

interface DashboardPageState {// extends ClaimList {
    loading: boolean
    // searchTxt: string
    // dialog: boolean,
    isExportReady: boolean,
    topTextHtml: string,
    startNewAppTextHtml: string,
    exportReadyNOTextHtml: string,
    exportReadyYESTextHtml: string,

}


export class DashboardPage extends React.Component<DashboardPageProps, DashboardPageState> implements ISupportSpinner {
    ajax: DashboardController
    // firstYearLink: HTMLAnchorElement
    constructor(props: DashboardPageProps) {
      super(props)

      this.ajax = new DashboardController()

      this.state = {
        // items: [],
        // years: [],
        loading: false,
        // searchTxt: '',
          // dialog: false,
        isExportReady: false, // default to false;
        topTextHtml: '',
        startNewAppTextHtml: '',
        exportReadyNOTextHtml: '',
        exportReadyYESTextHtml: '',
      }
    }

    componentDidMount() {
        // eslint-disable-next-line no-unused-vars
        this.ajax.dashboardy(this, (_d) => {
        // do nothing, just for authorisation purposes
    })


/* TODO REMOVE BELOW.
        this.ajax.getProgramSelectionPageInfo(this, s => {
        const el = document.getElementById('programSelectionPageInfo')
        el ? el.innerHTML = s : ''
        }, err => {
        console.log(err)
        })
*/
        // get Text from CRM
        fetch('/api/Dashboard/GetHomePageText', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                topTextHtml             : data.HOME_PAGE_TopText,
                startNewAppTextHtml     : data.HOME_PAGE_StartNewApplication,
                exportReadyNOTextHtml   : data.HOME_PAGE_ExportReadiness_Pending,
                exportReadyYESTextHtml  : data.HOME_PAGE_ExportReadiness_Completed,
            })
        })
        .catch((error) => {
            console.error('Error:', error);
        });

        // get the ABN of the logged-on User from Cookie.
        fetch('api/account/GetLoggedInUserInfo', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(response => {
            if (response.ok) {
                return response.json()
            }
            throw new Error('User info not found')
        })
        .then(data => {
            this.setExportReadyFlag(data.abn)
        })
        .catch(error => console.error('Error:', error))
    }


    /* TODO: DELETE this route was removed
    newClaim = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      this.props.history.push('/dashboard-forms')
    }


    newReform = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      this.props.history.push('/dashboard-reform')
    }
    */
    takeCourseExportReadiness = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      this.props.history.push('/export-readiness')
    }

    /* eslint-disable-next-line react/no-unused-class-component-methods, class-methods-use-this */
    setExportReadyFlag = (abn : string) => {
        // eslint-disable-next-line no-param-reassign
        // abn = '62159467697'; // For testing purpose, this ABN is ExportReady (true)

        // eslint-disable-next-line prefer-template
        const url = 'api/Dashboard/IsExportReady?abn=' + abn;
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(tf => {
            console.warn('Is-Export-Ready:', tf);
            this.setState({
                isExportReady: tf, // boolean, true,false
            })
        })
        .catch(error => console.error('Error:', error));
    }

    /* eslint-disable-next-line class-methods-use-this, react/no-unused-class-component-methods */
    zTestOnly = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()

        // put stuff here for temporary testing.
        // fetch(`/api/Dashboard/RetrieveTierSettings/?ApplicationPeriodCrmGuid=${encodeURIComponent('e4a90067-057c-ed11-81ad-00224814f98a')}`, {
        // fetch('/api/Dashboard/RetrieveTierSettings/?ApplicationPeriodCrmGuid=e4a90067-057c-ed11-81ad-00224814f98a', {
        fetch(`/api/Dashboard/RetrieveTierSettings/?ApplicationPeriodCrmGuid=${encodeURIComponent('e4a90067-057c-ed11-81ad-00224814f98a')}`, {
        method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                console.log('data:', data)
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }


    // eslint-disable-next-line react/no-unused-class-component-methods
    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    render() {
      return (
        <div className="container-fluid pt-5">
            <div dangerouslySetInnerHTML={{ __html: this.state.topTextHtml }} />

          {/* Browser requirements message Text from CRM moved to LoginPage
            <div style={{ marginTop: 30, display: 'none' }} id="programSelectionPageInfo" />

           <button type="button" onClick={this.zTestOnly}>Test only</button>
          */}

          <div style={{ marginTop: 30 }}>
            <h4>Austrade Export Readiness Test</h4>
            <div style={{ marginBottom: 10 }} dangerouslySetInnerHTML={{ __html: this.state.isExportReady ? this.state.exportReadyYESTextHtml : this.state.exportReadyNOTextHtml }} />

            {!this.state.isExportReady && (
                <Button
                  className="emdg-btn"
                  id="btnStartExportReadiness"
                  onClick={this.takeCourseExportReadiness}
                >
                    Start export readiness test
                </Button>
            )}

          </div>


          <MyDashboard
            history={this.props.history}
            startNewAppTextHtml={this.state.startNewAppTextHtml}
          />

          <Backdrop on={this.state.loading} />
        </div>
      )
    }
}
